import { RootState } from "store/index";

const menusInWeek = (state: RootState) => {
  return state.weeklyMenus.menus;
};

const menusInWeekStartDate = (state: RootState) => {
  return state.weeklyMenus.startDate;
};

const menusInWeekEndDate = (state: RootState) => {
  return state.weeklyMenus.endDate;
};

const menusInWeekMenuType = (state: RootState) => {
  return state.weeklyMenus.menuType;
};

const isMenusInWeekLoading = (state: RootState) => {
  return state.weeklyMenus.isLoading;
};

const menusInWeekError = (state: RootState) => {
  return state.weeklyMenus.error;
};

const menusInWeekWarnings = (state: RootState) => {
  return state.weeklyMenus.warnings;
};

const selectedMenusByDate = (state: RootState) => {
  return state.weeklyMenus.selectedMenusByDate;
};

const menusInWeekSelector = {
  menusInWeek,
  menusInWeekStartDate,
  menusInWeekEndDate,
  menusInWeekMenuType,
  isMenusInWeekLoading,
  menusInWeekError,
  menusInWeekWarnings,
  selectedMenusByDate,
};

export default menusInWeekSelector;
